import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FIDUCIARY_STATE_FEATURE_KEY, FiduciaryState } from './fiduciary.state';

export const selectFiduciaryFeature = createFeatureSelector<FiduciaryState>(FIDUCIARY_STATE_FEATURE_KEY);

export const selectTasksForWidget = createSelector(selectFiduciaryFeature, (state) => state.portalTasks.widget);

export const selectAllTasksForUser = createSelector(selectFiduciaryFeature, (state) => state.portalTasks.allTasksForUser);

export const selectTaskDetail = createSelector(selectFiduciaryFeature, (state) => state.portalTasks.taskDetail);

export const selectTaskComments = createSelector(selectFiduciaryFeature, (state) => state.portalTasks.taskComments);

export const selectTaskDocuments = createSelector(selectFiduciaryFeature, (state) => state.portalTasks.taskDocuments);

export const selectInboxUploadHistoryEntries = createSelector(selectFiduciaryFeature, (state) => state.inboxUploadHistory.entries);

export const selectInboxUploadHistoryDocumentDownload = createSelector(
  selectFiduciaryFeature,
  (state) => state.inboxUploadHistory.documentDownload,
);

export const selectAbacusInboxes = createSelector(selectFiduciaryFeature, (state) => state.abacusInboxes);
